import * as React from 'react'
import { Input, Row, Button } from 'antd'
import { FilterDropdownProps } from 'antd/lib/table'

interface Props<T> {
  placeholder?: string
  dataIndex: keyof T
  filterDropdownProps: FilterDropdownProps
  searchTable: (dataIndex: keyof T, searchText: string, confirm?: () => void) => void
  clearSearchResult: (clearFilters?: () => void) => void
  toggleDropdownVisible?: () => void
}

export const CustomFilterDropdown = <T extends { key: number }>(props: Props<T>) => {
  const {
    placeholder,
    dataIndex,
    filterDropdownProps,
    searchTable,
    clearSearchResult,
    toggleDropdownVisible,
  } = props
  const { setSelectedKeys, selectedKeys, confirm, clearFilters } = filterDropdownProps
  const searchText = selectedKeys ? (selectedKeys[0] ? selectedKeys[0].toString() : '') : ''

  return (
    <div className='p-2'>
      <Input
        placeholder={placeholder}
        className='mb-2'
        autoFocus
        value={searchText}
        onChange={(event) => {
          const value = event.target.value ? [event.target.value] : []
          if (setSelectedKeys) {
            setSelectedKeys(value)
          }
        }}
        onPressEnter={() => {
          searchTable(dataIndex, searchText, confirm)
          toggleDropdownVisible && toggleDropdownVisible()
        }}
      />
      <Row className='d-flex'>
        <Button
          type='primary'
          className='mr-1 w-100'
          onClick={() => {
            searchTable(dataIndex, searchText, confirm)
            toggleDropdownVisible && toggleDropdownVisible()
          }}
          icon='search'
          size='small'
        >
          Search
        </Button>

        <Button
          className='ml-1 w-100'
          onClick={() => {
            clearSearchResult(clearFilters)
            toggleDropdownVisible && toggleDropdownVisible()
          }}
          size='small'
        >
          Reset
        </Button>
      </Row>
    </div>
  )
}
